import { IconButton } from '@atgfr8/atg-ui-tailwind';
import { formatDataTestId } from '@utils/dataTestIdFormatter';
import { JSX } from 'solid-js';

type PropsT = {
  onClick: () => void;
  icon: JSX.Element;
  disabled?: boolean;
  sx?: JSX.CSSProperties;
  disabledColors?: string[];
  hoverColors?: string[];
  backgroundColor: string;
  title?: string;
  dataTestId?: string;
};

export const SquareIconButton = (props: PropsT) => {
  return (
    <IconButton
      dataTestId={
        props.dataTestId ??
        formatDataTestId(props.title ?? 'Square Icon Button', 'button')
      }
      title={props.title}
      class="[&:hover]:!bg-(--hover-bg-color) [&:hover]:!text-(--hover-color) disabled:!bg-(--disabled-bg-color) disabled:!text-(--disabled-color)
        [&>div]:flex [&>div]:items-center [&>div]:justify-center"
      style={{
        '--hover-bg-color': props.hoverColors?.[0],
        '--hover-color': props.hoverColors?.[1],
        '--disabled-bg-color':
          props.disabledColors?.[0] ?? 'rgba(0, 0, 0, 0.12)',
        '--disabled-color': props.disabledColors?.[1] ?? '#0000001F',
        ...(props.sx ?? {}),
        'background-color': props.disabled
          ? (props.disabledColors?.[0] ?? 'rgba(0, 0, 0, 0.12)')
          : props.backgroundColor,
        color: props.disabled
          ? (props.disabledColors?.[1] ?? 'rgba(0, 0, 0, 0.26)')
          : '#fff',
        'border-radius': '4px',
        'max-width': '30px',
        'max-height': '30px',
      }}
      disabled={props.disabled}
      onClick={props.onClick}
    >
      {props.icon}
    </IconButton>
  );
};
